<template>
  <div class="video-scale-wrap" :style="wrapStyle">
    <div class="video-scale" :style="videoStyle">
      <VideoPlayer
        ref="playerRef"
        @tagChange="tagChange"
      />
    </div>
  </div>
</template>
<script>
import VideoPlayer from '@/components/PolyvPlayer/index.vue'
export default {
  components: {
    VideoPlayer
  },
  props: {
    // 播放器的宽
    width: {
      type: Number,
      default: 523
    },
    // 播放器的高
    height: {
      type: Number,
      default: 294
    }
  },
  computed: {
    wrapStyle() {
      const { width, height } = this
      return {
        width: `${width}px`,
        height: `${height}px`
      }
    },
    videoStyle() {
      const { width, height } = this
      const videoHeight = 600
      const scale = height / videoHeight
      if (scale >= 1) {
        return {
          width: '100%',
          height: '100%'
        }
      }
      return {
        height: `${videoHeight}px`,
        width: `${width / scale}px`,
        transform: `scale(${scale})`
      }
    }
  },
  methods: {
    playerInit({ scriptJson, videoUrl }) {
      return this.$refs.playerRef.playVideo.ready({
        scriptJson,
        vid: videoUrl
      })
    },
    /**
     * 视频片段改变的回调
     */
    tagChange(tag, oldTag) {
      this.$emit('tagChange', tag, oldTag)
    },
    /**
     * 播放
     */
    play() {
      this.$refs.playerRef.play()
    },
    /**
     * 暂停
     */
    pause() {
      this.$refs.playerRef.pause()
    },
    /**
     * 关闭视频
     */
    stop() {
      this.$refs.playerRef.stop()
    },
    /**
     * 改变要播放的视频片段
     * tags: 视频片段数组
     */
    voChangeTags(tags) {
      this.stop()
      this.$refs.playerRef.playVideo.voChangeTags(tags)
    }
  }
}
</script>
<style lang="less" scoped>
.video-page {
  position: relative;
}
.video-scale-wrap {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.video-scale {
  position: absolute;
  // width: 1066px;
  // height: 600px;
  // transform: scale(324/600);
  transform-origin: top left;
  left: 0;
  top: 0;
}
</style>